class UserPushSettings {
  endpoints;

  populate(data) {
    this.endpoints = data.endpoints || [];
  }

  get hasEndpoints() {
    return this.endpoints.length > 0
  }

  constructor(data) {
    this.populate(data || {});
  }
}

export { UserPushSettings };
